var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout"},[(_vm.isLoading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loading-page"}):[_c('nav-menu'),_c('div',{staticClass:"main-content"},[_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }